



















import Vue from 'vue';

export default Vue.extend({
  name: 'UsageTerms',
  data: () => ({
    opened: false,
    terms: [
      {
        title: 'Plano Operacional - Sorteio',
        link: 'https://2020.fanaticosnortox.com.br/docs/operacional_regulamento_sorteio.pdf',
      },
      {
        title: 'Plano Operacional - Vale Brinde',
        link: 'https://2020.fanaticosnortox.com.br/docs/operacional_regulamento_vale_brinde.pdf',
      },
      {
        title: 'Regulamento - Sorteio',
        link: 'https://2020.fanaticosnortox.com.br/docs/operacional_regulamento_sorteio.pdf',
      },
      {
        title: 'Regulamento - Vale Brinde',
        link: 'https://2020.fanaticosnortox.com.br/docs/operacional_regulamento_vale_brinde.pdf',
      },
    ],
  }),
  methods: {
    open(): void {
      this.opened = true;
    },
    openLink(url: string): void {
      window.open(url, '_blank');
    },
  },
});
